const listdevicedefault = (state = [], action) => {
  switch (action.type) {
    case 'LIST_DEVICE_DEFAULT': {
      const novoItem = {
        type: 'LIST_DEVICE_DEFAULT',
        dispositivo: action.dispositivo,
        descricao: action.descricao
      };

      const stateSemMesmoDispositivo = state.filter(
        (item) => item.dispositivo !== action.dispositivo
      );

      return [...stateSemMesmoDispositivo, novoItem];
    }

    default:
      return state;
  }
};

export default listdevicedefault;